import useInitialConfigStore from "../../../../storeModules/useInitialConfigStore";
import useBotControlStore from "../../../../storeModules/useBotControlStore";
import findStep from "../../stepModules/findStep";
import BotButton from "../../../../components/bot-button";
import { getApiHealthCheck } from "../../../../api/requests";
import { ensureConversacao } from "../../../../api/requestsFunctions/conversacao";
import trackConversacaoStep from "../../../../utils/trackConversacaoStep";
import preventDoubleClick from "../../../../utils/preventDoubleClick";
import {
  OPENING_BLOCK_CTA,
  OPENING_BLOCK_STEP,
} from "../../../../utils/openingBlockConstants";

const appendUserMessage = (text) => {
  const controlStoreState = useBotControlStore.getState();
  const time = new Date().toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

  useBotControlStore.setState({
    ...controlStoreState,
    messages: [
      ...controlStoreState.messages,
      { sender: "user", text, time },
    ],
  });
};

const generateInitialCopys = (initialCopys, steps) => {
  if (initialCopys.length > 0) {
    const copyMessagesWithoutFirst = initialCopys.slice(1);

    const { button_color_text, button_color_background } =
      useInitialConfigStore.getState();

    copyMessagesWithoutFirst.forEach((copy, index) => {
      const stepName = `copy_intermediaria_${index + 2}`;
      const copyMessage = {
        name: stepName,
        sender: "bot",
        index: index + 1,
        text: copy.mensagem,
        action: () => {
          if (index + 1 < copyMessagesWithoutFirst.length) {
            useBotControlStore.setState({
              currentStep: findStep(`copy_intermediaria_${index + 3}`).index,
            });
          }
        },
        ...(copyMessagesWithoutFirst.length === index + 1 && {
          stepButtons: [
            <BotButton
              size="small"
              variant="default"
              text={OPENING_BLOCK_CTA}
              enabled={true}
              onClick={() =>
                preventDoubleClick(async () => {
                  appendUserMessage(OPENING_BLOCK_CTA);

                  await ensureConversacao("boas_vindas");

                  await trackConversacaoStep({
                    stepName: OPENING_BLOCK_STEP,
                    userMessage: OPENING_BLOCK_CTA,
                  });

                  await getApiHealthCheck();
                })
              }
              className="first-cta-button"
              {...(button_color_background &&
                button_color_text && {
                  style: {
                    backgroundColor: button_color_background,
                    color: button_color_text,
                  },
                })}
            />,
          ],
        }),
      };

      steps.push(copyMessage);
    });
  }
};

export default generateInitialCopys;
